import { useState } from "react";
import { DownloadButton } from "./ReportPDF";

const PROFILES = {
  INT: { name: "L'Intensif", emoji: "⚡" },
  PRE: { name: "Le Technicien", emoji: "🎯" },
  EXP: { name: "L'Artiste-Expressif", emoji: "🎨" },
  COM: { name: "Le Compétiteur", emoji: "⚔️" },
  COL: { name: "Le Collectif", emoji: "🤝" },
  SCE: { name: "Le Performeur", emoji: "🎭" },
  CRE: { name: "Le Créateur", emoji: "🔨" },
};

export default function GenerateReport({ childName, childAge, gender, primaryKey, secondaryKey, scores, questionnaire }) {
  const [status, setStatus] = useState("idle");
  const [reportText, setReportText] = useState("");
  const [error, setError] = useState("");

  const primary = PROFILES[primaryKey];
  const secondary = PROFILES[secondaryKey];

  async function generate() {
    setStatus("loading");
    setError("");
    try {
      const res = await fetch("/api/generate-report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ childName, childAge, gender, primaryProfile: primaryKey, secondaryProfile: secondaryKey, scores, questionnaire })
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      setReportText(data.report);
      setStatus("done");
    } catch (e) {
      setError("Une erreur est survenue. Réessaie.");
      setStatus("idle");
    }
  }

  const T = "#1B6B6B", TP = "#E0F4F4", G = "#E8C87A";

  if (status === "done") return (
    <div style={{ padding: 16, fontFamily: "system-ui" }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: "20px 24px", marginBottom: 12, borderLeft: `4px solid ${T}` }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: T, textTransform: "uppercase", marginBottom: 8 }}>
          Rapport généré ✅
        </div>
        <div style={{ fontSize: 14, fontStyle: "italic", color: "#4A3F72", lineHeight: 1.7, whiteSpace: "pre-wrap" }}>
          {reportText.slice(0, 400)}...
        </div>
      </div>
      <DownloadButton gender={gender}
        childName={childName}
        childAge={childAge}
        primaryProfile={primary}
        secondaryProfile={secondary}
        reportText={reportText}
      />
      <div style={{ fontSize: 12, color: "#8B7BB5", textAlign: "center", marginTop: 12 }}>
        Le PDF est généré localement dans ton navigateur
      </div>
    </div>
  );

  return (
    <div style={{ padding: 16, fontFamily: "system-ui" }}>
      <div style={{ background: TP, borderRadius: 16, padding: "20px 24px", marginBottom: 16, textAlign: "center" }}>
        <div style={{ fontSize: 32, marginBottom: 8 }}>{primary?.emoji}</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: T, marginBottom: 4 }}>{primary?.name}</div>
        <div style={{ fontSize: 13, color: "#2E8B8B", marginBottom: 12 }}>Profil principal</div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#C8E8E8", borderRadius: 100, padding: "6px 16px" }}>
          <span>{secondary?.emoji}</span>
          <span style={{ fontSize: 13, color: T, fontWeight: 600 }}>{secondary?.name} · profil secondaire</span>
        </div>
      </div>

      <div style={{ background: "#FDF6E3", borderLeft: `4px solid ${G}`, padding: "14px 16px", borderRadius: "0 12px 12px 0", marginBottom: 16, fontSize: 13, color: "#6B5000" }}>
        Matchkid va maintenant générer un rapport PDF personnalisé pour {childName || "votre enfant"} — avec les recommandations d'activités adaptées à son profil unique.
      </div>

      {error && (
        <div style={{ background: "#FFEBEE", borderLeft: "4px solid #C62828", padding: "12px 16px", borderRadius: "0 8px 8px 0", marginBottom: 16, fontSize: 13, color: "#C62828" }}>
          {error}
        </div>
      )}

      <button
        onClick={generate}
        disabled={status === "loading"}
        style={{ background: status === "loading" ? "#9BC4C4" : T, color: "#fff", border: "none", borderRadius: 100, padding: "16px", fontSize: 16, fontWeight: 700, cursor: status === "loading" ? "not-allowed" : "pointer", width: "100%" }}
      >
        {status === "loading" ? "⏳ Génération en cours..." : "✨ Générer mon rapport PDF"}
      </button>

      {status === "loading" && (
        <div style={{ textAlign: "center", fontSize: 13, color: "#2E8B8B", marginTop: 12 }}>
          Matchkid analyse le profil de {childName || "votre enfant"} et rédige les recommandations...
        </div>
      )}
    </div>
  );
}
